import React, { useState } from "react";
import {Container, Row, Col, Card, Carousel, Button, ListGroup,} from "react-bootstrap";
import {
  PeopleFill,
  CashStack,
  BellFill,
  FileEarmarkBarGraphFill,
  GraphUpArrow,
  ShieldLockFill,
  Download,
} from "react-bootstrap-icons";
import "./schoolproduct.scss";
import DemoCall from "./DemoCall";
import BookDemo from "./BookDemo";
import SEO from "./SEO";

function FinanceSodtDetails() {
  const [show, setShow] = useState(false);
    
      const [selectedProduct, setSelectedProduct] = useState("");
      
        const openDemo = (product) => {
         setSelectedProduct(product);
         setShow(true);
       }; 

  return (
    <div style={{ background: "#f4f7fb" }}>

      <SEO
  title="Finance Management & Loan Billing Software | Uiplus"
  description="Loan Management, EMI Billing, Financial Reporting and Finance ERP Software for businesses."
  keywords="Loan Management Software, EMI Billing System, Finance ERP Software, Loan Software India"
  url="https://uiplus.in/products/finance-management"
/>

      {/* HERO */}
      <div
        style={{
          background: "linear-gradient(135deg, #198754, #0d6efd)",
          color: "white",
          padding: "70px 0",
          textAlign: "center",
        }}
      >
        <h1 className="fw-bold">
          Finance Management & Loan Billing System
        </h1>
        <p>
          Smart Loan Processing • EMI Automation • Secure Financial Reports
        </p>
      </div>

      <Container className="py-5">

        {/* IMAGE SLIDER */}
        <Row className="mb-5">
          <Col>
            <div className="slider-wrapper">
              <Carousel>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/images/fin-finance-dashboard.png"
                    alt="Finance Dashboard"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/images/fin-finance-saving.png"
                    alt="EMI Reports"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/images/fin-finance-loan.png"
                    alt="EMI Reports"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src="/images/fin-finance-fd.png"
                    alt="EMI Reports"
                  />
                </Carousel.Item>
              </Carousel>
            </div>
          </Col>
        </Row>

        {/* ABOUT */}
        <Row className="mb-5">
          <Col>
            <h3 className="fw-bold mb-3">About the System</h3>
            <p style={{textAlign:'justify'}}>
              Our Finance Management & Loan Billing System helps businesses
              maintain accurate customer loan records, EMI payments,
              penalties and complete financial reporting with automated
              processing and secure data management.
            </p>
          </Col>
        </Row>

        {/* MODULES SECTION */}
        <h3 className="fw-bold mb-5 text-center">Core Modules</h3>

        <Row className="g-4 mb-5">

          {[
            {
              title: "Customer & Loan Management",
              desc: "Manage customer details, KYC, loan amount, tenure, interest rate, EMI schedule and loan history.",
              icon: <PeopleFill />,
              gradient: "gradient-blue",
            },
            {
              title: "Loan Processing & EMI Calculation",
              desc: "Automated EMI calculation, interest computation, tenure tracking and payment filtering.",
              icon: <CashStack />,
              gradient: "gradient-green",
            },
            {
              title: "EMI & Penalty Management",
              desc: "Grace period, penalty calculation, overdue tracking and auto adjustment in next EMI.",
              icon: <BellFill />,
              gradient: "gradient-orange",
            },
            {
              title: "Financial Reporting",
              desc: "Customer loan summary, EMI payment report, loan closure report and outstanding tracking.",
              icon: <FileEarmarkBarGraphFill />,
              gradient: "gradient-purple",
            },
            {
              title: "Analytics & Monitoring",
              desc: "Track repayment trends, defaulters, penalty accruals and overall financial performance.",
              icon: <GraphUpArrow />,
              gradient: "gradient-red",
            },
            {
              title: "Security & Data Protection",
              desc: "Secure encrypted system with reliable data storage and user access control.",
              icon: <ShieldLockFill />,
              gradient: "gradient-dark",
            },
          ].map((item, index) => (
            <Col md={6} lg={4} key={index}>
              <Card className="module-card border-0 rounded-4 h-100">
                <Card.Body>

                  <div className={`module-icon ${item.gradient}`}>
                    {React.cloneElement(item.icon, {
                      size: 28,
                      color: "#fff",
                    })}
                  </div>

                  <h5 className="fw-bold mt-3">{item.title}</h5>

                  <p className="text-muted">{item.desc}</p>

                </Card.Body>
              </Card>
            </Col>
          ))}

        </Row>

        {/* KEY FEATURES */}
        <h3 className="fw-bold mb-4 text-center">Key Features</h3>

        <Row className="mb-5">
          <Col md={6}>
            <ListGroup variant="flush">
              <ListGroup.Item>✅ Complete Customer Record Management</ListGroup.Item>
              <ListGroup.Item>✅ Loan Processing & Approval System</ListGroup.Item>
              <ListGroup.Item>✅ EMI Scheduler & Auto Reminder</ListGroup.Item>
            </ListGroup>
          </Col>
          <Col md={6}>
            <ListGroup variant="flush">
              <ListGroup.Item>✅ Penalty Management for Late Payments</ListGroup.Item>
              <ListGroup.Item>✅ Comprehensive Financial Reporting</ListGroup.Item>
              <ListGroup.Item>✅ User-Friendly Dashboard</ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>

        {/* WHY CHOOSE */}
        <Row className="mb-5">
          <Col>
            <h3 className="fw-bold mb-3 text-center">
              Why Choose Our Finance System?
            </h3>
            <p className="text-center">
              Automated Loan & EMI Processing • Secure & Reliable • Time-Saving
              • Accurate Financial Analytics • Customizable Features • SMS Option Available
            </p>
          </Col>
        </Row>

        {/* CTA BUTTONS */}

        {/* CTA BUTTONS */}
                <Row className="text-center">
                  <col className="md={4}"></col>
                  <Col className="md={2}">
                    <Button
                      variant="success"
                      className="rounded-pill px-4"
                       onClick={() => openDemo("Finance Application")}
                    >
                      Book Live Demo
                    </Button>
        
                  </Col>
                  <Col className="md={2}">
                   
                    <Button
                      variant="outline-success"
                      className="rounded-pill px-4"
                      href="/images/Finance-Management-Broucher.pdf"
                      download
                    >
                      <Download className="me-2" />
                      Download Brochure
                    </Button>
                  </Col>
                  <col className="md={4}"></col>
                </Row>
                
        

      </Container>

      <DemoCall />

      <BookDemo
          show={show}
          handleClose={() => setShow(false)}
          productName={selectedProduct}
        />

    </div>
  );
}

export default FinanceSodtDetails;
